import { useRedirectWhen } from '../../hooks/useRedirectWhen';
import { EXTERNAL_URLS } from '../../constants/urls';

export default function TenantScreeningServicesAddressesPage() {
  useRedirectWhen({
    condition: true,
    externalTo: EXTERNAL_URLS.SELECT_PROPERTY,
    replace: true,
  });

  return null;
}
